import { ValueOf } from './util';

/** 付与口座のenum */
export const EAccountType = {
  BONUS_VALUE: 'ボーナスバリュー',
  BASIC_POINT: '通常ポイント',
  BONUS_POINT: 'ボーナスポイント',
} as const;

export type AccountTypeKey = keyof typeof EAccountType;
export type AccountTypeValue = ValueOf<typeof EAccountType>;

export const accountTypeKeys = Object.keys(EAccountType) as (AccountTypeKey[]);

/** v-select用items */
export const accountTypeItems = accountTypeKeys
  .map((key) => ({
    title: EAccountType[key],
    value: key,
  }));
